import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Footer from "../layout/Footer";
import SimpleHeader from "../layout/SimpleHeader";
import errorImg from "../assets/images/ico_error.png";
import ButtonWrapDiv from "../components/common/ButtonWrapDiv";
import { useNavigate } from "react-router-dom";
import FunctionButton from "../components/common/FunctionButton";
import moment from "moment";
import { resetMenuAuthData } from "../store/action";
import { useDispatch } from "react-redux";

const ErrorWrap = styled.div`
  text-align: center;
  margin: 150px 0 80px;

  h4 p {
    font-size: 40px;
    color: #bbb;
    margin: 10px 0 0;
  }
`;

const NotiText = styled.div`
  font-size: 20px;
  margin: 40px 0 15px;
  white-space: pre-line;
`;

const DateText = styled.span`
  font-size: 15px;
`;

const ErrorPage = ({ errorCode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    sessionStorage.clear();
    dispatch(resetMenuAuthData());

    switch (errorCode) {
      case "404":
        setErrorMsg("Page Not found. Please try again.");
        break;
      default:
        setErrorMsg(
          "A problem has occurred on this web site. Please try again.\n " +
            "If this error continues, please contact support"
        );
        break;
    }
  }, [errorCode]);

  const handleHomeClick = () => {
    navigate("/login");
  };

  return (
    <div>
      <SimpleHeader />

      <div style={{ minHeight: "800px" }}>
        <ErrorWrap>
          <h4>
            <img src={errorImg} alt="error" />
            <p>Error</p>
          </h4>
          <NotiText>{errorMsg}</NotiText>

          <DateText>{moment().format("YYYY-MM-DD")}</DateText>
        </ErrorWrap>
        <ButtonWrapDiv className="btn_bottom">
          <FunctionButton
            className="big"
            value={"Home"}
            onClick={handleHomeClick}
          ></FunctionButton>
        </ButtonWrapDiv>
      </div>
      <Footer />
    </div>
  );
};

export default ErrorPage;
